/**
 * ============================================================================
 * PERSONALIZED DISCOVERY SET — 5-Fragrance Validator
 * ============================================================================
 * 
 * Purpose: Disable the Add to Cart button on Personalized Discovery Set
 * products until the customer actively selects 5 distinct fragrances.
 * 
 * Supports BOTH product setups:
 *   - Active product (Shark Apps):  properties[Fragrance One] through Five
 *   - Draft/Original product:       items[0]id through items[4]id
 * 
 * The script auto-detects which pattern is on the page and applies the same
 * validation logic to either.
 * ============================================================================
 */

(function () {
  'use strict';

  const DROPDOWN_NAMES_PATTERN_A = [
    'properties[Fragrance One]',
    'properties[Fragrance Two]',
    'properties[Fragrance Three]',
    'properties[Fragrance Four]',
    'properties[Fragrance Five]'
  ];

  const DROPDOWN_NAMES_PATTERN_B = [
    'items[0]id',
    'items[1]id',
    'items[2]id',
    'items[3]id',
    'items[4]id'
  ];

  const MAX_WAIT_MS = 10000;
  const POLL_INTERVAL_MS = 200;
  let elapsed = 0;
  let initialized = false;

  function findDropdowns() {
    let dropdowns = [];
    DROPDOWN_NAMES_PATTERN_A.forEach(function (name) {
      const el = document.querySelector('select[name="' + name + '"]');
      if (el) dropdowns.push(el);
    });
    if (dropdowns.length === 5) return dropdowns;

    dropdowns = [];
    DROPDOWN_NAMES_PATTERN_B.forEach(function (name) {
      const el = document.querySelector('select[name="' + name + '"]');
      if (el) dropdowns.push(el);
    });
    return dropdowns;
  }

  function waitForDropdowns() {
    if (initialized) return;
    const dropdowns = findDropdowns();

    if (dropdowns.length === 5) {
      initialized = true;
      init(dropdowns);
      return;
    }

    elapsed += POLL_INTERVAL_MS;
    if (elapsed >= MAX_WAIT_MS) {
      console.warn('[DISCOVERY-SET] Timed out waiting for 5 dropdowns. Found: ' + dropdowns.length);
      return;
    }

    setTimeout(waitForDropdowns, POLL_INTERVAL_MS);
  }

  function init(dropdowns) {
    console.log('[DISCOVERY-SET] Validator loaded — found all 5 fragrance dropdowns');

    const atcButton = document.querySelector('#AddToCart, [data-add-to-cart], [name="add"], button[type="submit"][class*="cart"]');
    if (!atcButton) {
      console.warn('[DISCOVERY-SET] Could not find Add to Cart button. Validator not running.');
      return;
    }

    // Reset auto-selected dropdowns to "Choose Option" / "Please select an option"
    dropdowns.forEach(function (dropdown) {
      const emptyOption = dropdown.querySelector('option[disabled][value=""]') || dropdown.querySelector('option[value=""]');
      if (emptyOption) {
        dropdown.value = '';
        emptyOption.selected = true;
      }
    });

    // Create the helper message above the ATC button
    const helperMsg = document.createElement('p');
    helperMsg.className = 'discovery-set-helper';
    helperMsg.style.cssText = 'margin: 8px 0; font-size: 14px; text-align: center; color: #666; font-style: italic;';
    atcButton.parentNode.insertBefore(helperMsg, atcButton);

    function validateSelections() {
      const selectedCount = dropdowns.filter(function (d) {
        return d.value && d.value.trim() !== '';
      }).length;

      const remaining = 5 - selectedCount;

      if (remaining === 0) {
        atcButton.disabled = false;
        atcButton.classList.remove('btn--disabled');
        atcButton.style.opacity = '';
        atcButton.style.cursor = '';
        helperMsg.style.display = 'none';
      } else {
        atcButton.disabled = true;
        atcButton.classList.add('btn--disabled');
        atcButton.style.opacity = '0.5';
        atcButton.style.cursor = 'not-allowed';
        helperMsg.style.display = 'block';

        if (selectedCount === 0) {
          helperMsg.textContent = 'Please select 5 fragrances to continue';
        } else if (remaining === 1) {
          helperMsg.textContent = 'Please select 1 more fragrance to continue';
        } else {
          helperMsg.textContent = 'Please select ' + remaining + ' more fragrances to continue';
        }
      }
    }

    dropdowns.forEach(function (dropdown) {
      dropdown.addEventListener('change', validateSelections);
    });

    validateSelections();

    const form = atcButton.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        const allSelected = dropdowns.every(function (d) {
          return d.value && d.value.trim() !== '';
        });
        if (!allSelected) {
          e.preventDefault();
          e.stopPropagation();
          alert('Please select all 5 fragrances before adding to cart.');
        }
      }, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForDropdowns);
  } else {
    waitForDropdowns();
  }
})();